import React, { useState } from 'react'
import { Link } from 'react-scroll';
import './Navbar.css';


function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if (window.innerWidth <= 960) {
            setButton(false)
        } else {
            setButton(true)
        }
    };

    window.addEventListener('resize', showButton)

    return (
       
        <>
            <nav className="navbar">
                <div className="navbar-container">
                    <div className="menu-icon" onClick={handleClick}>
                        <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>

                        <li className="nav-item">
                            <Link className='nav-links' duration={800} onClick={closeMobileMenu} activeClass="nav-links--active" smooth={true} spy={true} to="home">Home</Link>
                        </li>


                        <li className="nav-item">
                            
                            <Link className='nav-links' duration={800} onClick={closeMobileMenu} activeClass="nav-links--active" smooth={true} spy={true} to="about">About</Link>

                        </li>

                        <li className="nav-item">
                            <Link className='nav-links' duration={800} onClick={closeMobileMenu} activeClass="nav-links--active" smooth={true} spy={true} to="resume">Experience</Link>
                        </li>
                        <li className="nav-item">
                            <Link className='nav-links' duration={800} onClick={closeMobileMenu} activeClass="nav-links--active" smooth={true} spy={true} to="articles">Articles</Link>
                        </li>
                        <li className="nav-item">
                            <Link className='nav-links' duration={800} onClick={closeMobileMenu} activeClass="nav-links--active" smooth={true} spy={true} to="projects">Projects</Link>
                        </li>
                    </ul>

                </div>
            </nav>
        </>
    )
}

export default Navbar